var React = require('react');

function TrainInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"strokeLinecap":"square","x":"12","y":"5","width":"40","height":"40","rx":"4","key":0}),React.createElement("path",{"d":"M14 50h36m-38.953 5H53","key":1}),React.createElement("circle",{"strokeLinecap":"square","cx":"21","cy":"33","r":"3","key":2}),React.createElement("circle",{"strokeLinecap":"square","cx":"42.814","cy":"33","r":"3","key":3}),React.createElement("path",{"d":"M47.5 45L55 59M16.5 45L9 59","key":4}),React.createElement("path",{"strokeLinecap":"square","d":"M18 14h28v10H18z","key":5})]));
}

TrainInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = TrainInline;

TrainInline.default = TrainInline;
